

















import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  name: 'myDialog'
})
export default class MyDialog extends Vue {
  @Prop({ default: false }) public dialogFlag: boolean;
  @Prop({ default: true }) public hideMaskFlag: boolean;
  @Prop({ default: '300px' }) public width: string;
  @Prop({ default: '0 20px' }) public paddingForLR: string;
  @Prop({ default: '30px' }) public borderRadius: string;
};
